/**
 * 函数节流
 * @param {*} fn 
 * @param {*} delay 
 * @returns 
 */
const throttle = function throttle(fn,delay,ctx) {
	var lastTime = null;
	return function(){
		let nowTime = Date.now();
		if(!lastTime || nowTime - lastTime > delay) {
			fn.apply(ctx,arguments);
			lastTime = nowTime;
		}
	}
}

/**
 * 生成随机颜色
 * @param {*} n 
 * @returns 
 */
const randomColors = n => {
	const colors = [];
	for(let i = 0;i < n;i++) {
		colors.push(`#${Math.floor(Math.random() * 0xffffff).toString(16).padEnd(6, "0")}`)
	}
	return colors
}

/**
 * RGB转16进制
 * @param {*} r 
 * @param {*} g 
 * @param {*} b 
 * @returns 
 */
const rgbTohex = (r, g, b) => "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);

/**
 * 上传文件白名单
 */
const whiteType = ["website"];

export {
    throttle,
	randomColors,
	rgbTohex,
	whiteType
}